/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
export enum ErrorType {
    INVALID_TOKEN = 'INVALID_TOKEN', // 不合法的符号
    ERROR_KEY_TYPE = 'ERROR_KEY_TYPE', // 不合法的 KEY 格式
    NO_MATCH_KEY = 'NO_MATCH_KEY', // 无匹配语法项
    INVALID_VALUE = 'INVALID_VALUE', // 无效的值
    TYPE_ERROR = 'TYPE_ERROR', // 值类型错误
    NE_ENUM_VALUE = 'NO_EXIST_ENUM_VALUE', // 不存在的枚举值
    INVALID_SYMBOL = 'INVALID_SYMBOL'
}
